interface LocalWatchedEpisode {
  episodeId: number
  showId: number
  watchedAt: number
  episodeName?: string
  season?: number
  episode?: number
}

const LOCAL_WATCHED_KEY = 'tvmaze_local_watched_episodes'

export class LocalStorageService {
  static getWatchedEpisodes(): LocalWatchedEpisode[] {
    try {
      const stored = localStorage.getItem(LOCAL_WATCHED_KEY)
      return stored ? JSON.parse(stored) : []
    } catch (error) {
      console.error('Error reading watched episodes from localStorage:', error)
      return []
    }
  }

  static addWatchedEpisode(
    episodeId: number,
    showId: number,
    episodeName?: string,
    season?: number,
    episode?: number,
  ): void {
    try {
      const episodes = this.getWatchedEpisodes()
      const existingIndex = episodes.findIndex(ep => ep.episodeId === episodeId)

      const watchedEpisode: LocalWatchedEpisode = {
        episodeId,
        showId,
        watchedAt: Date.now(),
        episodeName,
        season,
        episode,
      }

      if (existingIndex >= 0) {
        episodes[existingIndex] = watchedEpisode
      } else {
        episodes.push(watchedEpisode)
      }

      localStorage.setItem(LOCAL_WATCHED_KEY, JSON.stringify(episodes))
    } catch (error) {
      console.error('Error saving watched episode to localStorage:', error)
    }
  }

  static removeWatchedEpisode(episodeId: number): void {
    try {
      const episodes = this.getWatchedEpisodes()
      const filtered = episodes.filter(ep => ep.episodeId !== episodeId)
      localStorage.setItem(LOCAL_WATCHED_KEY, JSON.stringify(filtered))
    } catch (error) {
      console.error('Error removing watched episode from localStorage:', error)
    }
  }

  static getLastWatchedForShow(showId: number): number {
    const episodes = this.getWatchedEpisodes()
    const showEpisodes = episodes.filter(ep => ep.showId === showId)
    return showEpisodes.reduce((latest, ep) => Math.max(latest, ep.watchedAt), 0)
  }

  static getShowsWithLocalWatches(): number[] {
    const episodes = this.getWatchedEpisodes()
    const showIds = new Set(episodes.map(ep => ep.showId))
    return Array.from(showIds)
  }
}
